var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-line w-100"},[_c('div',{staticClass:"content-left"},[_vm._t("start")],2),_c('div',{staticClass:"content-right"},[_vm._t("end")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }